import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { authInfo } from '../actions'
import { uploadImage } from '../lib/upload';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { setProduct, clearProductsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dropzone from 'react-dropzone';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  product: PropTypes.object,
  error: PropTypes.any,
  categories: PropTypes.any,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)
class ProductNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        description: null,
        parentCategory: null,
      },
      product: {
        id: 0,
        name: '',
        description: '',
        disabled: true,
        newproduct: true,
        isTaxable: true,
        tagline: '',
        img: '',
        allowsPersonalization: false,
        parentCategory: 0,
        relatedCategory: 0,
        yotpoId: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.product && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Product saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const product = this.state.product;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = product[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleCategoryChange(index, value, category) {
    const nextState = this.state.product;
    nextState[category] = value;
    this.setState({
      product: nextState,
    });
  }
  handleUploadedImage(name, value) {
    const nextState = this.state.product;
    _.set(nextState, name, value)
    this.setState({
      product: nextState,
      edited: true,
    });
    this.setRequiredParams()
  }
  handleChange(e) {
    const nextState = this.state.product;
    nextState[e.target.name] = e.target.value;
    if (e.target.type === 'checkbox') {
      nextState[e.target.name] = e.target.checked;
    } else {
      nextState[e.target.name] = e.target.value;
    }
    this.setState({
      product: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearProductsErrors());
    const pProduct = this.state.product;
    pProduct.tagline = (pProduct.tagline === null) ? '' : pProduct.tagline;
    this.props.dispatch(setProduct(pProduct));
  }
  handleCancel() {
    this.props.dispatch(clearProductsErrors());
    browserHistory.push('/products?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/products?page=1');
    }
  }
  onDrop(file, bucket) {
    const { dispatch, product } = this.props
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, product.id)
      .then((response) => {
        this.handleChange({
          target: {
            name: 'img',
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: 'img',
            value: file[0].name
          }
        })
        // alert(`Image upload failed: ${er}`);
        return '';
      });
  }
  render() {
    const categorySelect = _.map(this.props.categories, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      wideStyle: {
        marginRight: '2%',
        width: '700px',
      },
      inputStyleURL: {
        marginRight: '1%',
        width: '100%'
      },
    };
    return (
      <div className="products component" style={authPage}>
        <h2>New Product</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.product.name}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Tagline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.product.tagline}
            name="tagline"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <SelectField
            floatingLabelText="Parent Category"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="parentCategory"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            value={this.state.product.parentCategory}
            errorText={this.state.required.parentCategory}
            errorStyle={{ color: cyan500 }}
            onChange={(event, index, value) => this.handleCategoryChange(index, value, 'parentCategory')}
          >
            <MenuItem value={0} key={0} primaryText="None" />
            {categorySelect}
          </SelectField>
          <SelectField
            floatingLabelText="Related Category"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="relatedCategory"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            value={this.state.product.relatedCategory}
            onChange={(event, index, value) => this.handleCategoryChange(index, value, 'relatedCategory')}
          >
            <MenuItem value={0} key={0} primaryText="None" />
            {categorySelect}
          </SelectField>
          <TextField
            floatingLabelText="Yotpo ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.product.yotpoId}
            name="yotpoId"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Image"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.product.img}
            name="img"
            style={styles.inputStyleURL}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES FROM FILESTACK', res);
                  const targetName = 'img'
                  const targetValue = res.filesUploaded[0].url
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">UPLOAD PHOTO</p>
          </button>
          <br />
          <TextField
            floatingLabelText="Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.product.description}
            name="description"
            onChange={this.handleChange}
            style={styles.wideStyle}
            errorText={this.state.required.description}
            errorStyle={{ color: cyan500 }}
            multiLine={true}
          />
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="New Product"
                defaultChecked={this.state.product.newproduct}
                name="newproduct"
                onCheck={this.handleChange}
              />
            </li>
            <li>
              <Checkbox
                label="Disabled"
                defaultChecked={this.state.product.disabled}
                name="disabled"
                onCheck={this.handleChange}
              />
            </li>
            <li>
              <Checkbox
                label="Product is Taxable"
                defaultChecked={this.state.product.isTaxable}
                name="isTaxable"
                onCheck={this.handleChange}
              />
            </li>
            <li>
              <Checkbox
                label="Allows Personalization"
                defaultChecked={this.state.product.allowsPersonalization}
                name="allowsPersonalization"
                onCheck={this.handleChange}
              />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

ProductNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ProductNewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    product: state.products.product,
    error: state.products.error,
    categories: state.categories.results,
  };
}

export default withRouter(connect(mapStateToProps)(ProductNewPage));



// WEBPACK FOOTER //
// ./src/containers/ProductNewPage.js